module.exports = __webpack_public_path__ + "static/media/book_zabur_ae_ajam_persian_8.d6bb2d42.jpg";